import type {
  ContactResponse,
  ContactResponseListResponse,
  CreateContactRequest,
} from '../generated/model';

export const createContacts = (
  overrides: Partial<ContactResponseListResponse> = {},
): ContactResponseListResponse => ({
  items: [
    createContact(),
    createContact({
      email: 'pdevries@dexample.com',
      fullName: 'Piet de Vries',
      id: 'd34e5b5d-43ff-4cac-9087-3f843bd2c738',
    }),
    createCprManagementContact(),
  ],
  totalCount: 3,
  ...overrides,
});

export const createContact = (
  overrides: Partial<ContactResponse> = {},
): ContactResponse => ({
  email: 'jdejong@dexample.com',
  firstName: 'Jan',
  fullName: 'Jan de Jong',
  id: 'afd5e7af-2681-a5dc-3902-6c75cc096a98',
  lastName: 'jong',
  logOnEnabled: true,
  phone: '6 12341234',
  contactGroups: [{ id: '123456789', label: 'Algemene groep' }],
  ...overrides,
});

export const createCprManagementContact = (
  overrides: Partial<ContactResponse> = {},
): ContactResponse => ({
  email: 'fdejong@dexample.com',
  firstName: 'Fred',
  fullName: 'Fred de Jong',
  id: 'bfd5e7af-2681-a5dc-3902-6c75cc096a98',
  lastName: 'jong',
  logOnEnabled: false,
  phone: '6 12341234',
  contactGroups: [{ id: '123456789', label: 'Algemene groep' }],
  ...overrides,
});

export const createUpdateCprManagementContactRequest = (
  overrides: Partial<CreateContactRequest> = {},
): CreateContactRequest => ({
  firstName: 'Fred',
  lastName: 'de Jong',
  email: 'fred.dejong@dexample.com',
  phone: '6 12341234',
  contactGroups: [{ contactGroupId: '123456789', organisationId: '123971899' }],
  ...overrides,
});
